import React,{useEffect, useState} from 'react'
import SimpleTable from "../../../../../../../components/simpleTable/SimpleTable";
import { useDispatch, useSelector } from 'react-redux';
import CustomChip from "../../../../../../../components/customChip/CustomChip";
import CustomModal from "../../../../../../../components/customModal/CustomModal";
import './financialLookUpStyle.css'
import ResponseHandler from '../../../../../../../services/ResponseHandler';
import { getAllBanks,deleteFinancialSupportBank } from '../../../../../../../api/apiServices/financialSupportBankApi';
import FinancialForm from './financial_form/FinancialForm';
import FinancialLookUpFilter from './FinancialFilter';

function FinancialLookup() {
    const dispatch=useDispatch()
const [open, setOpen] = useState(false);
const [existingValue,SetExistingValue]=useState(null)
const [FinancialSupport,setFinancialSupport]=useState([])
const [rerenderUpdate,setrerenderUpdate]=useState(false)
const FinancialSup =useSelector((state)=>state.lookUpStore.FinancialSupport)
    useEffect(() => {
        dispatch(getAllBanks())
         
      }, [rerenderUpdate]);
      const Columns = [
        {
          title: "#",
          dataIndex: "key",
          key: "key",
        },
        {
          title: "bank name",
          dataIndex: "name",
          key: "name",
        },
        {
          title: "Contact Number",
          dataIndex: "contact_number",
          key: "contact_number",
        },
        {
          title: "Email Id ",
          dataIndex: "email_id",
          key: "email_id",
        },
        {
          title: "Actions",
          dataIndex: "Actions",
          key: "Actions",
          action: (row) => (
            <div  className="financialSupport_lookup_action_chipset">
              <CustomChip text="Edit" bgColor="#F8893C" color="white"  onClick={()=>{
                SetExistingValue(row)
                handleClickOpen()
              }} />
              <CustomChip text="Delete" bgColor="#ED5967" color="white" onClick={()=>{
                dispatch(deleteFinancialSupportBank(row.id)).then((response)=>{
                  ResponseHandler(response)
                  setrerenderUpdate(!rerenderUpdate)
                }).catch((error)=>{
                  ResponseHandler(error)
                })
              }}/>
            </div>
          ),
        },
      ];
     
      const Datas=()=>{
        const result= FinancialSup &&  FinancialSup.map((item,index)=>{
         
          return{
            key:index+1,
            id:item.foel_id,
            name:item.foel_name,
            contact_number:item.foel_contact_number,
            email_id:item.foel_email,
            address:item.foel_address,
          }
        })
        return result
        
      }
      const handleClickOpen = () => {
        setOpen(true);
      };
      const handleClose = (state) => {
        setOpen(state);
        SetExistingValue(null)
        setrerenderUpdate(!rerenderUpdate)
      };
  return (
    <div>
    <div className="financialSupport_lookup_header">
       <div>
         <FinancialLookUpFilter/>
       </div>
       <div>
       <button className="add_financialSupport_button" onClick={()=>{handleClickOpen()}}>
          Add Bank
        </button>
       </div>
    </div>
    <CustomModal
          open={open}
          handleClose={handleClose}
          body={<FinancialForm onClose={handleClose} existingvalue={existingValue}/>}
          title={existingValue?'Update Bank name':"Add Bank name"}
        />
     <SimpleTable columns={Columns} rows={Datas()}/>
  </div>
  )
}

export default FinancialLookup